import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import MenubarMenuItemInput from "../../../components/Menubar/MenubarMenuItemInput";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { getMenubarDataById } from "../../../utils/ApiCalls/Menubar";

const CreateMenubarMenuItem = () => {
  const params = useParams();
  const menubarId = params?.menubarId;
  const [menubar, setMenubar] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    { title: "Home", route: "/" },
    { title: "Menubar", route: "/website/cms/homepage/menubar" },
    { title: "Sub-menu", route: `/website/cms/homepage/menubar/${menubarId}/view` },
    { title: "Add Sub-menu", route: `/website/cms/homepage/menubar/${menubarId}/view/add` },
  ];

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menubarId]);

  const getData = async () => {
    dispatch({ type: "SET_LOADING", loading: true });
    let data = await getMenubarDataById(menubarId);
    if (!data?.error) setMenubar(data);
    dispatch({ type: "SET_LOADING", loading: false });
  };

  return (
    <Layout type={"create_per"} module_data={"Menubar"}>
      <HeaderBread navigation={navigation} title={"Add Sub-menu"}></HeaderBread>
      <MenubarMenuItemInput menubarId={menubarId} parentUrl={menubar?.url} submenu={{}} />
    </Layout>
  );
};

export default CreateMenubarMenuItem;
